import {
  Grid,
  Typography,
  Button,
  Link,
  Box,
  useNavigate,
  useTheme,
  useMediaQuery,
} from '@forgeglobal/design-framework';
import { object, string } from 'yup';
import {
  Form,
  Field,
  FormProps,
  FormRenderProps,
  FieldRenderProps,
} from '@tcs/common/components/atoms/Form';
import TextField from '@tcs/common/components/atoms/TextField';
import { useStyles } from '@tcs/client-portal/components/forms/EnterPasswordForm/style';
const EnterPasswordForm = ({ onSubmit }: FormProps) => {
  const validationSchema = object({
    username: string()
      .matches(
        /^(?![a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$)/,
        {
          message:
            'Account number starts with 3 letters followed by 6 numbers (and 1 additional letter if applicable). If you’re a rep, enter your rep ID.',
        }
      )
      .required('Account number or representative ID is required'),
    password: string().required('Password is required'),
  });

  const classes = useStyles();
  const nav = useNavigate();

  const linkTo = (path: string) => (e) => {
    nav(path);
    e.preventDefault();
  };

  const theme = useTheme();
  const smallBreakpoint = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Form
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        render={({ handleSubmit }: FormRenderProps) => {
          return (
            <form data-test-id="password-form" onSubmit={handleSubmit}>
              <Grid
                direction="column"
                container
                justifyContent="center"
                spacing={4}>
                <Grid item>
                  <Field
                    name="username"
                    render={(props: FieldRenderProps<string>) => (
                      <TextField
                        className={classes.textField}
                        data-test-id="login-id"
                        label={
                          smallBreakpoint
                            ? 'Account number (e.g., IRA123456)'
                            : 'Account number (e.g., IRA123456) or representative ID'
                        }
                        type="text"
                        autoComplete="username"
                        {...props}
                      />
                    )}
                  />
                </Grid>
                <Grid item className={classes.gridItem}>
                  <Field
                    name="password"
                    render={(props: FieldRenderProps<string>) => (
                      <TextField
                        className={classes.textField}
                        data-private
                        data-test-id="password"
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                        {...props}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  container
                  justifyContent="center"
                  className={classes.buttonContainer}>
                  <Button
                    data-test-id="login-button"
                    size="medium"
                    color="primary"
                    className={classes.button}
                    type="submit">
                    Sign In
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
      <Box mt={2}>
        <Grid item container justifyContent="center" spacing={1}>
          <Grid item>
            <Typography variant="body1">
              <Link
                href="/reset-password"
                data-test-id="forgot-password-link"
                onClick={linkTo('/reset-password')}>
                Forgot password?
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default EnterPasswordForm;
